import Markdown, { type Components } from "react-markdown";
import { isSafeMarkdownLink } from "@/lib/markdown-links";
import { cn } from "@/lib/utils";

const inlineElements = ["p", "strong", "em", "a"];
const blockElements = [...inlineElements, "ul", "ol", "li"];

const inlineComponents: Components = {
  a({ children, href }) {
    if (!href) return <>{children}</>;

    return (
      <a
        href={href}
        className="interaction-focus font-medium text-primary underline decoration-primary/40 underline-offset-2 hover:decoration-primary"
        target="_blank"
        rel="noreferrer"
      >
        {children}
      </a>
    );
  },
  p({ children }) {
    return <>{children}</>;
  },
};

const blockComponents: Components = {
  ...inlineComponents,
  ol({ children }) {
    return <ol className="list-decimal space-y-1 pl-5">{children}</ol>;
  },
  p({ children }) {
    return <p>{children}</p>;
  },
  ul({ children }) {
    return <ul className="list-disc space-y-1 pl-5">{children}</ul>;
  },
};

function safeUrlTransform(value: string) {
  return isSafeMarkdownLink(value) ? value : undefined;
}

export function GuideMarkdown({
  className,
  inline = false,
  markdown,
}: {
  className?: string;
  inline?: boolean;
  markdown: string;
}) {
  if (inline) {
    return (
      <Markdown
        allowedElements={inlineElements}
        components={inlineComponents}
        urlTransform={safeUrlTransform}
        unwrapDisallowed
      >
        {markdown}
      </Markdown>
    );
  }

  return (
    <div className={cn("grid gap-3", className)}>
      <Markdown
        allowedElements={blockElements}
        components={blockComponents}
        urlTransform={safeUrlTransform}
        unwrapDisallowed
      >
        {markdown}
      </Markdown>
    </div>
  );
}
